import { EDITOR_BASE_URL } from 'src/app/settings';
import { ROUTE_PATHS } from 'src/routes/_shared/routes.constants';

export const getValuesFromHash = (hash: string): Record<string, string> => {
  const hashArray = hash.split('&');
  let result: Record<string, string> = {};
  hashArray.forEach(pair => {
    let [key, value] = pair.split('=');
    result[decodeURIComponent(key)] = decodeURIComponent(value || '');
  });
  return result;
};

export const getValuesFromState = (hash: string): Record<string, string> => {
  const hashArray = hash.split('+');
  let result: Record<string, string> = {};
  hashArray.forEach(pair => {
    let [key, value] = pair.split(':');
    result[decodeURIComponent(key)] = decodeURIComponent(value || '');
  });
  return result;
};

export function isEditorAppUrl(url: string): boolean {
  const regex = new RegExp(`^${EDITOR_BASE_URL}/(\\?.*)?(\\#.*)?$`);
  return !!url.match(regex);
}

export const getQueryParam = (param: string) => {
  const params = new URLSearchParams(window.location.search);
  return params.get(param);
};

export const isEditorNew =
  window.location.pathname?.replaceAll('/', '') === ROUTE_PATHS.EDITOR_NEW ||
  window.location.pathname?.replaceAll('/', '') === ROUTE_PATHS.UPLOAD ||
  window.location.pathname?.replaceAll('/', '') === ROUTE_PATHS.EDIT;
